const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/selectors/i18nSelectors.ts';
import { SupportedLocale } from '../defs/generalDefs';
import { ReducerState } from '../defs/actionTypes';
import { createSelector } from 'reselect';
import { CommonStoreState } from '../reducers';

const selI18nRoot = (state: CommonStoreState): ReducerState => state.i18n;

export const selLocale = createSelector(
    [selI18nRoot],
    (state: ReducerState): SupportedLocale => state.get('locale') || 'de'
);
